import { useMemo } from "react";
import { useUserXp } from "./useUserXp";
import { useAchievementsSeen } from "./useAchievementsSeen";
import { Achievement, computeUnlockedAchievements } from "../utils/achievements";

export function useAchievements() {
    const { status: xpStatus, breakdown, hasProgress } = useUserXp();
    const { seen, markSeen, syncStatus: seenSyncStatus } = useAchievementsSeen();

    const unlocked = useMemo(
        () => (hasProgress ? computeUnlockedAchievements(breakdown) : []),
        [hasProgress, breakdown]
    );

    // Wait for BOTH the unlocked set and the seen set to have actually
    // loaded before trusting a diff between them - otherwise a returning
    // user's already-earned achievements would flash as "newly unlocked" on
    // every page load, before their real "seen" record has arrived.
    const isReady = hasProgress && seenSyncStatus !== "loading";
    const newlyUnlocked: Achievement[] = isReady
        ? unlocked.filter((achievement) => seen[achievement.id] !== "seen")
        : [];

    return { status: xpStatus, unlocked, newlyUnlocked, isReady, markSeen };
}
